<div class="row">
    <div class="col-md-12 need-config">
        <div class="row">
            <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-12">
                <div class="card block shadow">
                    <div class="card-header">
                        <div class="card-title">
                            <h2>Analyser un lien</h2>
                        </div>
                    </div>
                    <div class="card-body col-md-12">
                        <div class="card-text row">
                            <div class="col-md-12">
                                <div [ngClass]="{'d-none': loading}">
                                    <p>
                                        Copiez ici le lien d'une annonce Leboncoin, BienIci, Seloger... ou n'importe quel autre site compatible avec LyBox pour analyser l'annonce.
                                    </p>
                                    <mat-form-field>
                                        <mat-label>Lien de l'annonce</mat-label>
                                        <input matInput class="text" [(ngModel)]="url">
                                    </mat-form-field>
                                </div>
                                <div [ngClass]="{'d-none': !loading}">
                                    <mat-spinner diameter="50" color="second" class="float-left me-5"></mat-spinner>
                                    Récupération et analyse de l'annonce en cours ...<br/>
                                    Cela peut prendre jusqu'à 30 secondes.<br/>
                                    <br/>
                                </div>
                            </div>

                            <div class="col-12">
                                <div [ngClass]="{'d-none': loading}">
                                    <button (click)="saveSimulation(true)" class="btn d-block">
                                        <i class="fa fa-line-chart"></i> Lancer la simulation
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
